
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-use-x-chat-demo-openai","docs-x-sdk-use-x-chat-demo-deepseek","docs-x-sdk-use-x-chat-demo-defaultmessages","docs-x-sdk-use-x-chat-demo-developer","docs-x-sdk-use-x-chat-demo-custom-request-fetch","docs-x-sdk-use-x-chat-demo-request-openai-node"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/use-x-chat.en-US.md?type=demo')
};